'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOnlineMode = exports.getSenderId = exports.getAwayMessage = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY_PATHS = {
  ONLINE: ['online'],
  CUSTOM_AWAY_MESSAGE: ['message', 'customAwayMessage'],
  SENDER_ID: ['responder', 'userId']
};

var getAwayMessage = exports.getAwayMessage = (0, _pipe2.default)((0, _getIn2.default)(KEY_PATHS.CUSTOM_AWAY_MESSAGE), function (awayMessage) {
  return awayMessage || _I18n2.default.text('default.awayMessage');
});

var getSenderId = exports.getSenderId = (0, _pipe2.default)((0, _getIn2.default)(KEY_PATHS.SENDER_ID), function (senderId) {
  return senderId && '' + senderId;
});

var isOnlineMode = exports.isOnlineMode = (0, _getIn2.default)(KEY_PATHS.ONLINE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/models/WidgetDataModel.js
// module id = 206
// module chunks = 0 1